import React from 'react';
import PosterPresentation2023 from 'views/PosterPresentation2023';

const AccountGeneralPage = () => {
  return <PosterPresentation2023 />;
};

export default AccountGeneralPage;
